import router from '../router/index';
import RootState from './RootState';
import {
    Module,
    ActionTree,
    ActionContext,
    GetterTree,
    MutationTree,
} from 'vuex';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
// @ts-ignore
import querystring from 'querystring';

const tokenKey = 'asea.token';

export interface AuthenticationState {
    username?: string;
    token?: string;
    isAuthenticated: boolean;
}

// @ts-ignore
export const state: AuthenticationState = {
    username: undefined,
    token: undefined,
    isAuthenticated: false,
};

export const actions: ActionTree<AuthenticationState, RootState> = {
    async login(
        context: ActionContext<AuthenticationState, RootState>,
        { username, password }: any,
    ) {
        const response = await axios.post(
            'https://api.diamondsupport.aseaglobal.com/token',
            // 'http://localhost:5000/token',
            querystring.stringify({
                username,
                password,
                grant_type: 'password',
                scope: 'openid',
            }),
        );

        const token = response.data.access_token;

        // save the epoch when the token expires
        const tokenExpireSeconds = response.data.expires_in;
        const tokenExpiration = new Date(
            Date.now() + tokenExpireSeconds * 1000,
        ).getTime();
        localStorage.setItem('asea.token.expiration', tokenExpiration.toString());

        context.commit('loginSuccess', { username, token });
        router.push('/userDashboard');
    },
    loginWithToken(
        context: ActionContext<AuthenticationState, RootState>,
        { username, token }: any,
    ) {
        context.commit('loginSuccess', { username, token });
        const currentUrl = window.location.href;
        router.push('/userDashboard').catch(()=>{});

    },
    logout(context: ActionContext<AuthenticationState, RootState>): void {
        context.commit('logout');
        router.push('/login');
    },
};

export const getters: GetterTree<AuthenticationState, RootState> = {
    isAuthenticated(state: AuthenticationState): boolean {
        return state.isAuthenticated === true;
    },
    username(state: AuthenticationState): any {
        return state.username;
    },
};

export const mutations: MutationTree<AuthenticationState> = {
    loginSuccess(state: AuthenticationState, user: any) {
        state.username = user.username;
        state.token = user.token;
        state.isAuthenticated = true;
        localStorage.setItem(tokenKey, user.token);
        localStorage.setItem('asea.user.name', user.username);
        axios.defaults.headers.common.Authorization = `Bearer ${user.token}`;
    },
    logout(state: AuthenticationState) {
        state.username = undefined;
        state.token = undefined;
        state.isAuthenticated = false;
        axios.defaults.headers.common.Authorization = null;
    },
};

export const authentication: Module<AuthenticationState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
